module.exports = "/_next/static/images/team-staffing-expansion-header-03f7a3b83cb07c047249d0afd1dd400f.webp";